/**
 * Shared chart utility functions used across analytics and dashboard components.
 */

/**
 * Calculate a y-axis max value with 20% padding, rounded to a clean number.
 * Handles both single datasets and multi-dataset arrays (array-of-arrays).
 * Returns 10 as a minimum for empty or all-zero data.
 */
export function calculateDynamicMax(data: number[] | number[][]): number {
  let maxValue = 0;

  if (Array.isArray(data) && data.length > 0) {
    if (Array.isArray(data[0])) {
      (data as number[][]).forEach(dataset => {
        if (dataset?.length > 0) {
          const valid = dataset.filter(v => !isNaN(v) && isFinite(v));
          if (valid.length > 0) maxValue = Math.max(maxValue, Math.max(...valid));
        }
      });
    } else {
      const valid = (data as number[]).filter(v => !isNaN(v) && isFinite(v));
      if (valid.length > 0) maxValue = Math.max(...valid);
    }
  }

  if (maxValue <= 0) return 10;

  const padded = maxValue * 1.2;
  if (padded <= 10) return Math.ceil(padded);
  if (padded <= 100) return Math.ceil(padded / 10) * 10;
  if (padded <= 1000) return Math.ceil(padded / 100) * 100;
  return Math.ceil(padded / 1000) * 1000;
}
